module.exports = __webpack_public_path__ + "media/images/email/facebook-f-517e07361ef2782004b1c8a7a5d986de.svg";